/**
 * Builds the value of the data-mdlfy-cms attribute that makes database text editable in the preview.
 * Format: <table>:<row id>:<column>. Returns undefined when the row id is missing so no broken tag is emitted.
 */
export const cms = (table: string, id: string | null | undefined, column: string): string | undefined => id ? `${table}:${id}:${column}` : undefined
